import { Injectable } from '@angular/core';

export enum MapMode {
    BBOX_SHAPING = 'bbox_shaping',
}

@Injectable({
    providedIn: 'root',
})
export class MapModeService {
    private _mapModeStatus: Map<MapMode, boolean> = new Map<MapMode, boolean>([[MapMode.BBOX_SHAPING, false]]);

    public get isBboxShapingActive(): boolean {
        return this._mapModeStatus.get(MapMode.BBOX_SHAPING) ?? false;
    }

    public set isBboxShapingActive(value: boolean) {
        this._mapModeStatus.set(MapMode.BBOX_SHAPING, value);
    }
}
